const WEBSITE_URL = "https://formfunction.xyz/";

export default WEBSITE_URL;
